<div id="wrap" class="moWrap">
    <header class="header">
        <div class="header_inner">
            <a a routerLink="/m/mypage" class="btn_prev"><span class="blind">이전 페이지로 이동하기</span></a>
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right">
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
        </div>
    </header>

    <div id="content">
        <div id="skip_anchor" class="content page_mypage">
            <p class="top_notice">버디활동(등록/수정 등)은 PC에서만 가능합니다.</p>
            <div class="db_box_inner">
                <strong class="db_box_title">내 실적 <span class="db_box_title_sub">(최근 3개월)</span></strong>

                <!-- table-세로 -->
                <div class="table-row">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">링크명</th>
                                <th scope="col">구매건수</th>
                                <th scope="col">구매금액</th>
                                <th scope="col">예상수익</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of list">
                                <td>
                                    <div class="dis_flex">
                                        <div class="img_area">
                                          <a href="https://www.oasis.co.kr{{item.urlValue}}" target="_blank">
                                              <img src="{{item.filePath}}" alt="썸네일 이미지" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'">
                                          </a>
                                        </div>
                                        <a class="info_area line-2">
                                            {{item.title}}
                                        </a>
                                    </div>
                                  </td>
                                  <td>{{item.buyEventCount | number}}</td>
                                  <td>{{item.totalPayment | number}}</td>
                                  <td>{{item.commissionPrice | number}}</td>
                            </tr>
                            <ng-container *ngIf="!(list && list.length > 0)">
                                <tr>
                                    <td colspan="4" class="nodata">내역이 없습니다.</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </div>
